import { memo } from "react";
// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import useAuth from "hooks/useAuth";

// ==============================|| SIDEBAR MENU LIST ||============================== //

// Function to filter the menu items based on access_data.
const filterMenuItems = (menuItems, accessData) => {
  // console.log("🚀 ~ filterMenuItems ~ menuItems:", menuItems)
  if (accessData === null || accessData === undefined || !accessData) {
    return menuItems.filter((item) => item.id === 'dashboard');
  } else {
    return menuItems.map((item) => {
      if (item.type === 'group') {
        // add the dashboard -> dont remove
        if (item.id === 'dashboard') {
          return item;
        }
        // Filter the children of the group based on access_data.
        if (item?.children?.length > 0 && accessData) {
          const filteredChildren = item && item?.children?.length > 0 && item?.children?.filter(
            (child) => accessData[child?.id] && child?.id !== 'dashboard'
          );
          return { ...item, children: filteredChildren };
        }
      }
      return item;
    }).filter(item => item?.children?.length > 0 || item.id === 'dashboard');
  }
};

const MenuList = () => {
  const { admin } = useAuth();

  const filteredMenuItems = filterMenuItems(menuItem.items, admin.access_data);
  // console.log("🚀 ~ MenuList ~ filteredMenuItems:", filteredMenuItems)

  const navItems = filteredMenuItems.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default memo(MenuList);
